export { request } from './request';
export { getApiUrl } from './config';

import { BRM_AL_URL_HOST } from '../host';

import { rootApi } from './modules/root';
import { channelApi } from './modules/channel';
import { heartbeatApi } from './modules/heartbeat';
import { cronJobApi } from './modules/cronjob';
import { chatApi, sessionApi } from './modules/chat';
import { envApi } from './modules/env';
import { providerApi } from './modules/provider';
import { skillApi } from './modules/skill';
import { agentApi } from './modules/agent';
import { workspaceApi } from './modules/workspace';
import { localModelApi } from './modules/localModel';
import { ollamaModelApi } from './modules/ollamaModel';
import { mcpApi } from './modules/mcp';
import { toolsApi } from './modules/tools';
import { voiceTranscriptionApi } from './modules/voiceTranscription';
import { tokenUsageApi } from './modules/tokenUsage';
import { securityApi } from './modules/security';
import { agentsManagementApi } from './modules/agents';

// 使用环境变量 VITE_BRM_AI_MAIN，兼容国内/国际版（海外为 finenter.ai）
const brmAiMain = BRM_AL_URL_HOST || '';
const openClawBaseUrl = brmAiMain.replace(/\/api\/?$/, '') || 'https://sse.comein.cn';
const openClawChatApi = `${openClawBaseUrl}/api/copaw/console/chat`;

export const api = {
  ...rootApi,
  ...channelApi,
  ...heartbeatApi,
  ...cronJobApi,
  ...chatApi,
  ...sessionApi,
  ...envApi,
  ...providerApi,
  ...agentApi,
  ...skillApi,
  ...workspaceApi,
  ...localModelApi,
  ...ollamaModelApi,
  ...mcpApi,
  ...toolsApi,
  ...voiceTranscriptionApi,
  ...tokenUsageApi,
  ...securityApi,
  ...agentsManagementApi
};

export const OPEN_CLAW_BASE_URL = openClawBaseUrl;
export const OPEN_CLAW_CHAT_API = openClawChatApi;

export default api;
